<template>
  <div
    class="wrapper"
    :class="{
      'wrapper--personal': currentUserMessages,
      'pointer wrapper--selectReady': chatSelectedMessages.length > 0,
    }"
    @click="
      chatSelectedMessages.length > 0
        ? SELECT_chatSelectedMessages({ id: message.id, senderId: message.senderId })
        : undefined
    "
    @contextmenu="handleContextMenu"
    :data-index="messageKey"
    :data-id="message.id"
    :data-unSeen="!currentUserMessages && !message.isSeen"
    :id="'message_' + message.id"
  >
    <div
      class="chat_correspondence__user__message d-flex flex-column py-2 px-4 gap-1"
      :class="{
        'chat_correspondence__user__message--error': message.status === 'error',
        'chat_correspondence__user__message--select': !!chatSelectedMessages.find(
          (i) => i.id === message.id,
        ),
      }"
    >
      <div
        v-if="chatItem.type !== 'PERSONAL' && !currentUserMessages && messageKey === 0"
        class="chat_correspondence__user__message__header primary--text f14"
      >
        {{ formatShowingData.sender_name }}
      </div>
      <div v-if="message.originalMessageId" class="primary--text f14">
        {{
          localStorage.translations.pages.chat.all.forward_from +
          ' ' +
          formatShowingData.forward_sender_name
        }}
      </div>
      <div v-if="formatShowingData.content" class="chat_correspondence__user__message__body">
        {{ formatShowingData.content }}
      </div>
      <div
        class="chat_correspondence__user__message__files gap-2"
        v-if="formatShowingData.attachments !== null"
      >
        <template v-for="(file, fileKey) in formatShowingData.attachments">
          <BaseFileView
            :key="fileKey"
            :itemKey="fileKey"
            :items="formatShowingData.attachments"
            :isRead="!Boolean(message.status)"
            :isUpload="!!message.status"
            :sortMessageFiles="sortMessageFiles"
            :uploadInfo="
              chatFileUploads && chatFileUploads[identity] && chatFileUploads[identity][fileKey]
            "
            :needApiDomain="chatApiDomain + '/static'"
          />
        </template>
      </div>
      <div class="chat_correspondence__user__message__date f12 unselectable">
        <BaseIcon
          v-if="message.updatedAt && $formatDate(message.updatedAt) !== $formatDate(message.sentAt)"
          icon="button-edit"
          color="#1e8ac4"
        />
        {{
          $formatDate(
            message.updatedAt
              ? $formatDate(message.updatedAt) !== $formatDate(message.sentAt)
                ? message.updatedAt
                : message.sentAt
              : message.sentAt,
          )
        }}
        <div v-if="currentUserMessages" class="chat_correspondence__user__message__status">
          <template v-if="message.status">
            <BaseIcon
              :icon="message.status === 'waiting' ? 'loader-clock' : 'mark-warning'"
              :color="message.status === 'waiting' ? '#277faf' : '#f2f2f2'"
            />
          </template>
          <div
            v-else
            class="chat_correspondence__user__message__seen"
            :class="{ 'chat_correspondence__user__message__seen--true': message.isSeen }"
          >
            {{ '✓' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ChatСorrespondenceMessage',
  props: {
    message: Object,
    chatItem: Object,
    findUserById: Object,
    messageKey: Number,
    observer: IntersectionObserver,
    identity: String,
    onFindUserById: Function,
  },
  data() {
    return {
      avatarSize: 75,
      uploadFiles: {},
    }
  },
  created() {
    if (this.message.status === 'waiting') {
      this.onSendMessage()
    }
  },
  mounted() {
    this.observer.observe(this.$el)
  },
  computed: {
    ...mapState(['chatApiDomain']),
    ...mapGetters('user', ['userData']),
    ...mapState('chat', ['chatsConfig']),
    ...mapState('chat/messages', ['chatSelectedMessages']),
    ...mapState('chat/file', ['chatFileUploads']),
    currentUserMessages() {
      return this.message.senderId === this.userData.id
    },
    sortMessageFiles() {
      let result = null
      if (this.message.attachments && this.message.attachments !== null) {
        result = {}
        for (let acceptedKey in this.chatsConfig.files.accepted) {
          result[acceptedKey] = []
          for (let file of this.message.attachments) {
            if (typeof file === 'string' && this.onThisFileIsType({ file, type: acceptedKey })) {
              result[acceptedKey].push(this.chatApiDomain + '/static/' + file)
            }
          }
        }
      }
      return result
    },
    formatShowingData() {
      let forward_sender_name
      if (this.message.originalMessage) {
        const findForwardSenderUserData = this.onFindUserById({
          userId: this.message.originalMessage.senderId,
        })
        forward_sender_name =
          findForwardSenderUserData &&
          findForwardSenderUserData.first_name + ' ' + findForwardSenderUserData.last_name
      }
      return {
        sender_name:
          this.findUserById && this.findUserById.first_name + ' ' + this.findUserById.last_name,
        forward_sender_name,
        content: this.message.originalMessage
          ? this.message.originalMessage.content
          : this.message.content,
        attachments: this.message.originalMessage
          ? this.message.originalMessage.attachments
          : this.message.attachments,
      }
    },
  },
  methods: {
    ...mapActions('chat/messages', [
      'SEND_chatMessage',
      'SELECT_chatSelectedMessages',
    ]),
    ...mapActions('chat/file', ['POST_chatFile']),
    handleContextMenu(value) {
      this.$emit('contextmenu', value)
    },
    onSendMessage() {
      const chatId_send = this.$route.params.id
      let data = {
        content: this.message.content,
        chatIds: [chatId_send],
      }
      if (this.message.attachments && this.message.attachments.length) {
        data.files = this.message.attachments
      }
      this.SEND_chatMessage({
        data,
        identity: this.identity,
      })
    },
    onThisFileIsType({ file, type }) {
      // look all "type" in this.chatsConfig.files
      return this.chatsConfig.files.accepted[type].some((substring) => file.includes(substring))
    },
  },
  beforeDestroy() {
    this.observer.unobserve(this.$el)
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  .chat_correspondence__user__message {
    background: var(--v-secondary-lighten4);
    border-radius: 20px 20px 20px 20px;
    width: fit-content;
    height: max-content;
    max-width: 750px;
    transition: 0.3s;
    position: relative;
    &__body {
      white-space: pre-line;
    }
    &__files {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    &__date {
      color: var(--v-primary-darken1);
      justify-content: flex-start;
      display: flex;
      gap: 5px;
      user-select: none;
      :deep().base-icon {
        width: auto;
        height: 12px;
      }
    }
    &__seen {
      width: 10px;
      display: flex;
      justify-content: center;
      position: relative;
      &--true {
        &:before {
          content: '✓';
          position: absolute;
          left: 5px;
        }
      }
    }
    &.highlighting {
      z-index: 0;
      box-shadow: 0 0 5px var(--v-primary-base);
      &::before {
        box-shadow: 0 0 5px var(--v-primary-base);
      }
    }

    &--error {
      background: var(--v-error-base);
      color: var(--v-secondary-lighten4);
      .chat_correspondence__user__message__date {
        color: var(--v-secondary-lighten4) !important;
      }
    }
    &--select {
      background: var(--v-primary-lighten5) !important;
    }
  }
  &:last-of-type {
    .chat_correspondence__user__message {
      border-radius: 20px 20px 20px 0px;
      &::before {
        content: '';
        background: inherit;
        width: 10px;
        height: 5px;
        position: absolute;
        left: -10px;
        border-radius: 30px 0 0 0;
        bottom: 0;
        transition: 0.3s;
      }
    }
  }
  &--personal {
    display: flex;
    justify-content: flex-end;
    // .chat_correspondence__user__messages {
    //   align-items: end;
    // }
    .chat_correspondence__user__message {
      background: var(--v-secondary-lighten2);
      &__date {
        justify-content: flex-end;
      }
    }
    &:last-of-type {
      .chat_correspondence__user__message {
        border-radius: 20px 20px 0px 20px;
        &::before {
          left: auto;
          right: -10px;
          border-radius: 0 30px 0 0;
        }
      }
    }
  }
  &--selectReady {
    user-select: none;
    .chat_correspondence__user__message__files {
      pointer-events: none;
    }
  }
}
</style>
